import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ProjectModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { ProjectSetupAction } from '../actions';
import { ProjectSetupReducer } from '../reducers';
import { ProjectSetupSelector } from '../selectors';

@Injectable()
export class ProjectSetupFacade {
  selectedItem$ = this._store.select(ProjectSetupSelector.selectProjectSetup);
  constructor(private _store: Store<ProjectSetupReducer.ProjectSetupState>) {}

  /**
   * Get @ProjectModel by id
   */
  getById(id: number): Observable<ProjectModel | null> {
    this._store.dispatch(ProjectSetupAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<ProjectModel | null>;
  }
}
